import axios from '@/plugins/axios'

/**
 * Create responsible squad
 */
const createResponsibleSquad = async ({
  // eslint-disable-next-line camelcase
  advertiser_id = null,
  // eslint-disable-next-line camelcase
  company_id = null,
  users
}) => {
  try {
    const form = {
      users
    }
    // eslint-disable-next-line camelcase
    if (advertiser_id) form.advertiser_id = advertiser_id
    // eslint-disable-next-line camelcase
    if (company_id) form.company_id = company_id
    const response = await axios.post('admin/responsible-squads', form)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Destroy responsible squad
 */
const destroyResponsibleSquad = async (id) => {
  try {
    const response = await axios.post(`admin/responsible-squads/${id}`, {
      _method: 'DELETE'
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get responsible squad
 */
const getResponsibleSquad = async ({
  // eslint-disable-next-line camelcase
  advertiser_id = null,
  // eslint-disable-next-line camelcase
  company_id = null,
  page = 1
}) => {
  try {
    const params = {
      page: page
    }
    // eslint-disable-next-line camelcase
    if (advertiser_id) params.advertiser_id = advertiser_id
    // eslint-disable-next-line camelcase
    if (company_id) params.company_id = company_id

    const response = await axios.get('admin/responsible-squads', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  createResponsibleSquad,
  destroyResponsibleSquad,
  getResponsibleSquad
}
